module.exports = __webpack_public_path__ + "img/icon-33.fea94b7d.svg";